// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"239":"79196518","531":"c898639c"}[chunkId] + ".css";
};